export class SignoutRedirect {
    constructor() {
        jQuery(() => {
            window.addEventListener("load", () => {
                const a = document.querySelector("a.PostLogoutRedirectUri") as HTMLAnchorElement;
                if (a) {
                    window.location.href = a.href;
                }
            });
        });
    }
}

if (/\/Account\/LoggedOut\/?$/i.test(location.pathname)) {
    const signoutWindow = window as any;
    signoutWindow.signoutRedirect = new SignoutRedirect();
}